/**
 * Owner: Masa Bayu
 * File: commerce-checkout.ts
 * Date:Time: 2026-09-15 22:25
 * Description: T3-E1 checkout hand-off — cart → totals (≠ payment execution).
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { cartHasBlockingIssues } from './commerce-cart';
import { calculateCommerceTotals } from './commerce-pricing';
import { assertT3E1SecurityIntact } from './commerce-security';
import { createQxreadId } from './id';
import { assertTimestamp, assertValidId } from './guards';
export const QXREAD_CHECKOUT_STATES = ['draft', 'ready', 'blocked'];
export function createCheckoutFromCart(cart, options) {
    assertNoForbiddenFoundationKey(options ?? {}, 'QXRead checkout');
    assertT3E1SecurityIntact();
    assertValidId(cart.cartId, 'QXRead checkout cartId');
    assertValidId(cart.sessionKey, 'QXRead checkout sessionKey');
    const checkoutId = options?.checkoutId !== undefined ? options.checkoutId : createQxreadId('qxrdchk');
    assertValidId(checkoutId, 'QXRead checkoutId');
    const createdAt = options?.createdAt ?? new Date().toISOString();
    assertTimestamp(createdAt, 'QXRead checkout createdAt');
    const blockers = [];
    if (cart.lines.length === 0) {
        blockers.push('Cart is empty');
    }
    if (cartHasBlockingIssues(cart)) {
        blockers.push('Cart has invalid, unavailable, or price-changed lines');
    }
    if (blockers.length > 0) {
        return Object.freeze({
            checkoutId,
            cartId: cart.cartId,
            sessionKey: cart.sessionKey,
            state: 'blocked',
            totals: null,
            blockers: Object.freeze(blockers),
            createdAt,
        });
    }
    const totals = calculateCommerceTotals({
        correlationId: checkoutId,
        affiliateAccountId: options?.affiliateAccountId ?? null,
        referralAccountId: options?.referralAccountId ?? null,
        lines: cart.lines.map((line) => ({
            publicationId: line.publicationId,
            quantity: line.quantity,
            snapshot: line.snapshot,
        })),
    });
    return Object.freeze({
        checkoutId,
        cartId: cart.cartId,
        sessionKey: cart.sessionKey,
        state: 'ready',
        totals,
        blockers: Object.freeze([]),
        createdAt,
    });
}
//# sourceMappingURL=commerce-checkout.js.map